import { AnimationDuration, getDistributionDelay } from "@uno/protocol";
import { AnimationValue } from "../types/Animation";
import { computeDeckToHandEffects } from "./utils";
import { getRoomLayoutSnapshot } from "utils/RoomLayout";

const FromDeckToRoomPlayersHandsAnimation = (location: Element, index: number, playerCount: number): AnimationValue => {
    const { scales, deckRotation } = getRoomLayoutSnapshot();
    const isOpponent = !!location.closest(".opponent");
    const delayPerCard = getDistributionDelay(playerCount);
    const delay = index * delayPerCard;
    const duration = AnimationDuration.FromDeckToRoomPlayersHands;
    const targetScale = isOpponent ? scales.opponent : scales.hand;

    return {
        duration: delay + duration,
        effects: (el: HTMLElement) => {
            const effects = computeDeckToHandEffects(el, deckRotation, targetScale);

            if(!effects) {
                return [];
            }

            effects[0].opacity = ["0", "1"];
            return effects;
        },
        transitions: [{ delay, duration, fill: "backwards" }],
    };
};

export default FromDeckToRoomPlayersHandsAnimation;
